var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("Onay Bekleyen Marka")]),_c('div',[_vm._v(" Bu markaya ait ürünler için marka talebiniz alınmıştır. Markanız onaylandıktan sonra ürün onay süreciniz başlayacaktır. ")])])
}]

export { render, staticRenderFns }